import { IconButton, IconButtonProps, SvgIconProps } from '@mui/material';

import InfoIcon from '../../../assets/icons/InfoIcon';
import colors from '../../../constants/colors';

interface InfoButtonProps extends IconButtonProps {
  iconProps?: SvgIconProps;
}

const InfoButton = ({ iconProps, sx, ...props }: InfoButtonProps) => {
  return (
    <IconButton
      disableRipple
      {...props}
      sx={{
        p: 0,
        fill: `${colors.csaaBlack}33`,
        '&:hover': {
          backgroundColor: 'transparent',
          fill: colors.csaaNeutralBorder,
        },
        ...sx,
      }}
    >
      <InfoIcon {...iconProps} />
    </IconButton>
  );
};

export default InfoButton;
